import React from 'react';
import Hero from "./components/skill-development/Hero";
import Main from "./components/skill-development/Main";

const SkillDevelopment = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default SkillDevelopment;